/* eslint-disable no-useless-escape */
import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../features/Loader/LoaderSlice';

const ResendOTPModal = ({ isOpen, setIsOpen, onEmailChange }) => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState('');

  const sendOTP = () => {
    const getUrl = process.env.REACT_APP_API_URL;
    const url = getUrl;
    if (!email || email.length <= 0) {
      toast.error('Please enter complete email address', { id: 'email' });
    } else if (
      !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email
      )
    ) {
      toast.error('Please enter a valid email address', { id: 'email' });
    } else {
      dispatch(loaderActions.show());
      axios
        .post(`${url}/resend-code/${email}`, {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then((result) => {
          if (result.status === 200) {
            toast.success('OTP sent successfully! Please check your email');
            onEmailChange(email);
            setIsOpen(false);
          } else {
            toast.error(result.data, { id: 'error' });
          }
        })
        .catch((err) => {
          console.error(
            'Error occurred during addition\nError: ',
            err.response.data.message ?? err.response.data
          );
          toast.error(err.response.data.message ?? err.response.data);
        })
        .finally(() => {
          dispatch(loaderActions.hide());
        });
    }
  };

  return (
    <React.Fragment>
      <Modal show={isOpen} centered onHide={() => setIsOpen(false)}>
        <Modal.Header closeButton>
          <Modal.Title as="h5">Request New OTP</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col sm={12}></Col>
            <Col sm={12}>
              <div className="form-group fill"></div>
            </Col>
          </Row>
          <Form.Row>
            <Form.Control
              className="text-normal"
              size="lg"
              type="email"
              placeholder="Email Address"
              required
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <div className="mt-4" style={{ width: '100%' }}>
              <Button size="small" className="login_forgot_password_button" onClick={sendOTP} block>
                Send OTP
              </Button>
            </div>
          </Form.Row>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default ResendOTPModal;
